import { useEffect, useState } from 'react';

import { Typography } from '@mui/material';
import { Membership } from '../../../../models/membership';
import { Box } from '@mui/system';
import { formatDate } from '../../../../utils/dates';

interface SubscriptionsProps {
  membership: Membership;
}

export const SubscriptionSeats = ({ membership }: SubscriptionsProps) => {
  const headsetAccess = membership.getHeadsetAccess();
  if (!headsetAccess) {
    return <></>;
  }
  const renewalDate = membership.subscription.contracts[0]?.renewalDate;

  const nextTermEnd = new Date(renewalDate?.formatted || '');
  nextTermEnd.setFullYear(nextTermEnd.getFullYear() + 1);

  return (
    <>
      <p>
        <strong>Current Access:</strong> {headsetAccess.currentPeriodValue + 1}{' '}
        Headsets
      </p>

      {headsetAccess.nextPeriodValue < headsetAccess.currentPeriodValue && (
        <Box sx={{ marginTop: '-0.5rem' }}>
          <em>
            {headsetAccess.nextPeriodValue + 1} Headsets (
            {!renewalDate
              ? 'next Term'
              : formatDate({
                  date: new Date(renewalDate.formatted),
                  fullMonth: false
                })}
            )
          </em>
        </Box>
      )}
    </>
  );
};
